<template>
  <div style="background-color: #F5F7FA;height: 100%;">
    <div style="padding: 20px;position: relative;">
        <template>
          <el-row>
            <el-button plain type="primary"  @click="AddSOSContacts" >添加</el-button>
            <!-- <el-button :loading="loading" type="primary" @click="EditContacts">编辑</el-button> -->
          </el-row>
          <el-table v-loading="tableLoading"  :data="contactsInfo" style="margin: 10px 0; "  height="410">

            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>

            <el-table-column  label="操作" width="150" >
              <template slot-scope="scope">
                <el-button type="primary" size="small"
                           @click.native.prevent="deleteRow(scope.$index, contactsInfo)">
                  删除
                </el-button>
              </template>
            </el-table-column>



          </el-table>
        </template>
        <div class="footer">
            <el-button :loading="loading" type="success" @click="EditContacts">提交</el-button>
          </div>
      </div>
    <AddContacts ref="AddContacts" v-show="addContactsShow"  v-on:closeAddContacts="closeAddContacts"  v-on:getData="getData"   >  </AddContacts>
  </div>
</template>

<script>

import AddContacts from "./AddContacts";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: "SOSContacts",
  data() {
    return {
      addContactsShow:false,
      tableLoading:false,
      userCode: '',
      contactsInfo:[],
    }
  },
  components: {
    AddContacts
  },

  methods: {
    init(userCode) {
      this.userCode = userCode;
      this.getListSOSContacts();
    },
    closeSelf() {
      this.$emit("closeSOSContacts");
    },
    closeAddContacts(){
      this.addContactsShow =!this.addContactsShow;
    },
    deleteRow(index,rows){
      rows.splice(index, 1);
    },
    getData(contacts){
      this.contactsInfo.push(contacts);
    },
    AddSOSContacts(){
      console.log(this.contactsInfo.length)
      if(this.contactsInfo.length>2){
        this.$message({type: 'warning', message: 'SOS联系人只能添加三个!'});
      }else {
        this.$refs.AddContacts.init();
        this.addContactsShow =!this.addContactsShow;
      }
    },
    getListSOSContacts(){
      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$institutionUrl + "Positioning/ListSOSContacts",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userCode: this.userCode
        }
      }).then(
          (response) => {
            this.tableLoading=false
            if (response.data.error === 0) {
              this.contactsInfo=response.data.data;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },
    EditContacts(){
      if(this.contactsInfo.length===0){
        this.$message({type: 'warning', message: '请先添加SOS联系人！'});
      }else {
        this.$axios({
          method: 'post',
          url: this.$institutionUrl + "Positioning/EditSOSContacts",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            userCode: this.userCode,
            phones:this.contactsInfo
          }
        }).then(
            (response) => {
              if (response.data.error === 0) {
                this.$message({type: 'success', message: '编辑成功'});
                this.$emit("closeSOSContacts");
              } else if (response.data.error === 1) {
                this.$message({type: 'warning', message: response.data.message});
              }else {
                this.$message({type: 'warning', message: '编辑失败'});
              }
            }
        )
      }



    }


  }


}
</script>

<style lang="scss" scoped>
.footer{
  display: flex;
  justify-content: center;
  margin-top: 10px;
  .el-button{
    width: 180px;
  }
}
</style>